import React from 'react';
import { WebinarLink } from './WebinarLink';
export const MoreTestimonials = ({
  openModal
}) => {
  // Replace 'webinar' with WebinarLink component in text
  const replaceWebinarWithLink = text => {
    const parts = text.split(/(\bwebinar\b)/i);
    return parts.map((part, index) => {
      if (part.toLowerCase() === 'webinar') {
        return <WebinarLink key={index} onClick={openModal} data-id="element-109">
            webinar
          </WebinarLink>;
      }
      return part;
    });
  };
  return <section className="mb-10" data-id="element-110">
      <h2 className="text-xl font-bold text-blue-800 mb-6" data-id="element-111">
        Meer reacties van deelnemers
      </h2>
      <div className="space-y-4" data-id="element-112">
        {/* Liset's testimonial */}
        <div className="flex items-start" data-id="element-113">
          <div className="flex-shrink-0 mr-3" data-id="element-114">
            <div className="w-12 h-12 bg-blue-500 rounded-md flex items-center justify-center text-white text-xl font-bold" data-id="element-115">
              L
            </div>
          </div>
          <div className="flex-1 bg-gray-50 p-4 rounded-lg" data-id="element-116">
            <div className="flex justify-between mb-1" data-id="element-117">
              <span className="font-bold" data-id="element-118">Liset</span>
              <span className="text-gray-500 text-sm" data-id="element-119">21:29</span>
            </div>
            <p data-id="element-120">Super bedankt. Was boeiend en leerzaam.</p>
          </div>
        </div>
        {/* Linda's testimonial */}
        <div className="flex items-start" data-id="element-121">
          <div className="flex-shrink-0 mr-3" data-id="element-122">
            <div className="w-12 h-12 bg-purple-500 rounded-md flex items-center justify-center text-white text-xl font-bold" data-id="element-123">
              L
            </div>
          </div>
          <div className="flex-1 bg-gray-50 p-4 rounded-lg" data-id="element-124">
            <div className="flex justify-between mb-1" data-id="element-125">
              <span className="font-bold" data-id="element-126">Linda</span>
              <span className="text-gray-500 text-sm" data-id="element-127">21:39</span>
            </div>
            <p data-id="element-128">
              leuk filmpje :-) Zie mezelf en mijn "hondenkleinkids" :)))
              aangenaam verast.
              <br data-id="element-129" />
              Dankjewel voor de masterclass
            </p>
          </div>
        </div>
        {/* Karin and Annemieke testimonials */}
        <div className="flex items-start" data-id="element-130">
          <div className="flex-shrink-0 mr-3" data-id="element-131">
            <div className="w-12 h-12 bg-purple-500 rounded-md flex items-center justify-center text-white text-xl font-bold" data-id="element-132">
              K
            </div>
          </div>
          <div className="flex-1 bg-gray-50 p-4 rounded-lg" data-id="element-133">
            <div className="flex justify-between mb-1" data-id="element-134">
              <span className="font-bold" data-id="element-135">Karin</span>
              <span className="text-gray-500 text-sm" data-id="element-136">21:40</span>
            </div>
            <p data-id="element-137">Heel erg bedankt, het was heel leerzaam</p>
          </div>
        </div>
        <div className="flex items-start" data-id="element-138">
          <div className="flex-shrink-0 mr-3" data-id="element-139">
            <div className="w-12 h-12 bg-blue-500 rounded-md flex items-center justify-center text-white text-xl font-bold" data-id="element-140">
              A
            </div>
          </div>
          <div className="flex-1 bg-gray-50 p-4 rounded-lg" data-id="element-141">
            <div className="flex justify-between mb-1" data-id="element-142">
              <span className="font-bold" data-id="element-143">Annemieke</span>
              <span className="text-gray-500 text-sm" data-id="element-144">21:40</span>
            </div>
            <p data-id="element-145">heel erg bedankt voor de masterclass! groetjes, Annemieke</p>
          </div>
        </div>
        {/* Jessica's testimonial */}
        <div className="flex items-start" data-id="element-146">
          <div className="flex-shrink-0 mr-3" data-id="element-147">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/e2XikCMQaZbQPPWTtN2TFx/Jessica_mail_MCC_2.png" alt="Jessica" className="w-12 h-12 object-cover rounded-md" data-id="element-148" />
          </div>
          <div className="flex-1 bg-gray-50 p-4 rounded-lg" data-id="element-149">
            <div className="flex justify-between mb-1" data-id="element-150">
              <span className="font-bold" data-id="element-151">Jessica</span>
              <span className="text-gray-500 text-sm" data-id="element-152">aan mij</span>
            </div>
            <p className="mb-2" data-id="element-153">Hi Amee,</p>
            <p className="mb-2" data-id="element-154">Super, het is gelukt. Dankjewel!</p>
            <p className="mb-2" data-id="element-155">
              Ik wilde nog mijn complimenten geven voor de masterclass van
              gisteren. Ik heb menig gratis {replaceWebinarWithLink('webinar')}s
              gevolgd en vond die van jou echt wel de beste. Ben benieuwd naar
              de cursussen!
            </p>
            <p data-id="element-156">Groeten, Jessica</p>
          </div>
        </div>
        {/* Corrie's testimonial */}
        <div className="flex items-start" data-id="element-157">
          <div className="flex-shrink-0 mr-3" data-id="element-158">
            <div className="w-12 h-12 bg-purple-500 rounded-md flex items-center justify-center text-white text-xl font-bold" data-id="element-159">
              C
            </div>
          </div>
          <div className="flex-1 bg-gray-50 p-4 rounded-lg" data-id="element-160">
            <div className="flex justify-between mb-1" data-id="element-161">
              <span className="font-bold" data-id="element-162">Corrie</span>
              <span className="text-gray-500 text-sm" data-id="element-163">21:40</span>
            </div>
            <p data-id="element-164">Bedankt voor je heldere uitleg! Fijne avond</p>
          </div>
        </div>
      </div>
    </section>;
};